<script lang="ts" setup>
import { computed } from 'vue';
import BaseLabel from '@/atoms/BaseLabel.vue';

type Color = 'error' | 'success' | 'warning';

type Props = {
  value?: string | number;
  suffix?: string;
  text?: string;
  color?: Color;
};

const props = withDefaults(defineProps<Props>(), {
  color: 'error',
});

const colorClasses: Record<Color, { container: string; text: string; label: Color }> = {
  error: {
    container: 'border-red-200 bg-error-primary',
    text: 'text-error-primary',
    label: 'error',
  },
  success: {
    container: 'border-green-200 bg-success',
    text: 'text-success-primary',
    label: 'success',
  },
  warning: {
    container: 'border-orange-dark-200 bg-warning-primary',
    text: 'text-warning-primary',
    label: 'warning',
  },
};

const classes = computed(() => colorClasses[props.color]);
</script>

<template>
  <!-- 🔢 VERSION VALUE -->
  <div
    v-if="value !== undefined"
    class="w-full rounded-2xl border flex items-center justify-center"
    :class="[classes.container]"
  >
    <div class="flex items-end gap-1 py-7" :class="classes.text">
      <span class="text-5xl font-medium">
        {{ value }}
      </span>

      <BaseLabel
        v-if="suffix"
        :text="suffix"
        :color="classes.label"
        class="text-5xl font-medium"
        preset="medium"
        weight="regular"
      />
    </div>
  </div>

  <!-- 📝 VERSION TEXT -->
  <div
    v-else-if="text"
    class="w-full rounded-2xl border p-4"
    :class="[classes.container]"
  >
    <BaseLabel :text="text" :color="classes.label" preset="medium" weight="regular" />
  </div>
</template>
